import promisify from "lib/promisify";
import BaseServices from "lib/BaseServices";

const dehydrate = m => ({
    activeAt: (m.activeAt || moment()).valueOf(),
    expiresAt: m.expiresAt.valueOf(),
    message: m.message.trim(),
});

const rehydrate = m => ({
    ...m,
    activeAt: moment(m.activeAt),
    expiresAt: moment(m.expiresAt),
});

class BroadcastServices {

    getMessages(after) {
        return promisify(BaseServices.getRequest(
            "broadcast?after=" + after,
            null,
            { background: true },
        )).then(ms => ms.map(rehydrate));
    }

    getAllMessages() {
        return promisify(BaseServices.getRequest(
            ["broadcast", "admin"]
        )).then(ms => ms.map(rehydrate));
    }

    createMessage(m) {
        return promisify(BaseServices.jsonPost(
            ["broadcast", "admin"],
            dehydrate(m),
        ));
    }

    deleteMessage(m) {
        return promisify(BaseServices.jsonPost(
            ["broadcast", "admin", m.id],
            null,
            { type: "DELETE" },
        ));
    }

}

export default new BroadcastServices();



// WEBPACK FOOTER //
// ./app/lib/BroadcastServices.js